import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.network.dns.domain.renew;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_DNS_DOMAIN_RENEW',
	method: 'POST',
	url: '/network/dns/domain/renew.json',
});

export { actions, reducer, sagas, selectors };
